// Route constants
export const LOGIN_ROUTE: string = "/login";
export const HOME_ROUTE: string = "/home";
export const CLASSES: string = "/classes";
export const SIGN_UP: string = "/sign-up";
export const SIGN_UP_GROUPS: string = "/sign-up/groups";
export const REGISTRATION_ROUTE: string = "/registration";
export const TEST_ERROR_ROUTE: string = "/test-error";
export const TICKETS: string = "/tickets";
export const PURCHASE_HISTORY: string = "/purchase_history";
export const BONUSES: string = "/bonuses";
export const VISITS_HISTORY: string = "/visits_history";
export const SWIMMERS_DIARY: string = "/achievements";
export const CERTIFICATES: string = "/certificates";
export const FILEUPLOADER: string = "/fileuploader";
export const REFUND_APPLICATION: string = "/refund-application";
export const FREEZE_APPLICATION: string = "/freeze-application";
export const BUY_TICKET: string = "/buy-ticket";
export const PAYMENTS_SUCCESS: string = "/payments/success";
export const PAYMENTS_FAIL: string = "/payments/fail";

// Business constants
export const AKVASTAR_EMAIL_SUFFIX = "@akvastar.ru";
export const INTERNAL_CLUB_ID = "246e5cc0-ae65-11ef-9106-2a618cb265e1"; // Internal club not shown to regular users
export const AUTH_CODE_TIMER_SECONDS = 60;
export const DEFAULT_MONTHS_AHEAD = 2; // Default months ahead for appointment dates
